const React = require('react');

const Container = require('../common/Container.jsx');
const Content = require('../common/Content.jsx');
const Kit = require('../utility/Kit.jsx');
const List = require('../common/List.jsx');
const Name = require('../utility/Name.jsx');
const PaymentCreditCell = require('./PaymentCreditCell.jsx');
const TypeConfig = require('../common/TypeConfig.jsx');
const Utilities = require('../utility/Utilities.jsx');

function _Header(props) {
    if (props.config && props.config.config && props.config.config.Header && !Utilities.isHTMLContentEmpty(props.config.config.Header.design)) {
        let styleHeader;
        if (props.config.config.Header.paddingBottom && props.config.config.Header.paddingBottom.value && props.config.config.Header.paddingBottom.value.length > 0) {
            styleHeader = { paddingBottom: `${props.config.config.Header.paddingBottom.value}${props.config.config.Header.paddingBottom.unit}` };
        }
        const design = Kit.updateDesign(props.config.config.Header.design, props.kit);
        let content = (
            <tr>
                <td colSpan={props.config.config.Block && props.config.config.Block.columns}>
                    <div dangerouslySetInnerHTML={{ __html: design }} style={styleHeader} />
                </td>
            </tr>
        )
        if (!props.builder) {
            content = (
                <table border="0" cellPadding="0" cellSpacing="0" width="100%">
                    <tbody>
                        {content}
                    </tbody>
                </table>
            )
        }
        return content;
    }
    return null;
}
const _TypeConfigHeader = {
    panel: {
        header: (defaultText) => {
            const group = 'header';
            return {
                group,
                label: 'Header',
                options: [
                    {
                        display: 'Design',
                        fullWidth: true,
                        group,
                        name: 'design',
                        type: 'rich-text-collateral-short',
                        value: Utilities.wrapTextForEditor({ tag: Name.Stylesheet.Header2, text: defaultText })
                    },
                    {
                        display: 'Line Spacing',
                        fullWidth: true,
                        group,
                        max: '100',
                        name: 'paddingBottom',
                        options: TypeConfig.dropdown.measurement(),
                        type: 'measurement-slider',
                        value: { "unit": "px", "value": "10" }
                    }
                ]
            }
        }
    }
}

// #region CREDITS

function CreditsTableV2(props) {
    const data = props.data || {};
    if (!props.builder && (!data.IssuedCredits || !data.IssuedCredits.length)) {
        return null;
    }
    return <List.Container.Component cellComponent={PaymentCreditCell.Container.Component} header={<_Header {...props} />} records={data.IssuedCredits} {...props} />
}

const TypeConfigCreditsV2 = {
    panel: {
        block: () => List.Container.TypeConfig.panel.block(Name.Content.CreditLineItem, { itemSeparatorSize: { "unit": "px", "value": "" }, itemSpacing: { "unit": "px", "value": "10" } }),
        header: () => _TypeConfigHeader.panel.header('Credits'),
        style: List.Container.TypeConfig.panel.style
    }
}

// #endregion CREDITS

// #region PAYMENTS

function PaymentsTableV2(props) {
    const data = props.data || {};
    if (!props.builder && (!data.Payments || !data.Payments.length)) {
        return null;
    }
    let records;
    if (props.config && props.config.config) {
        if (props.config.config.Block && props.config.config.Block.includeRefunds) {
            records = [];
            data.Payments.forEach(payment => {
                records.push(payment);
                if (payment.Refunds) {
                    payment.Refunds.forEach(refund => records.push(refund));
                }
            })
        } else {
            records = data.Payments;
        }
    }
    return <List.Container.Component cellComponent={PaymentCreditCell.Container.Component} header={<_Header {...props} />} records={records} {...props} />
}

const TypeConfigPaymentsV2 = {
    panel: {
        block: () => {
            const blockConfig = List.Container.TypeConfig.panel.block(Name.Content.PaymentLineItem, { itemSeparatorSize: { "unit": "px", "value": "" }, itemSpacing: { "unit": "px", "value": "10" } })
            blockConfig.options.push({
                display: 'Include refunds',
                fullWidth: true,
                group: blockConfig.group,
                name: 'includeRefunds',
                type: 'checkbox',
                value: true
            });
            return blockConfig;
        },
        header: () => _TypeConfigHeader.panel.header('Payments'),
        style: List.Container.TypeConfig.panel.style
    }
}

// #endregion PAYMENTS

// #region LEGACY

function PaymentsTable(props) {
    const data = props.data || {};
    if (!props.builder && (!data.Payments || !data.Payments.length)) {
        return null;
    }
    let includes = {};
    if (props.config && props.config.Config && props.config.Config.Includes) {
        includes = props.config.Config.Includes;
    }
    return (
        <Table {...props}>
            {
                data.Payments.map(function (d, i) {
                    return (
                        <React.Fragment key={i}>
                            <PaymentRow config={props.config} data={data} index={i} payment={d} />
                            {
                                includes.Refunds &&
                                d.Refunds &&
                                d.Refunds.map((r, j) => <PaymentRow key={j} config={props.config} data={data} payment={r} />)
                            }
                        </React.Fragment>
                    );
                })
            }
        </Table>
    )
}

function CreditsTable(props) {
    const data = props.data || {};
    if (!props.builder && (!data.IssuedCredits || !data.IssuedCredits.length)) {
        return null;
    }
    return (
        <Table {...props}>
            {
                data.IssuedCredits.map((d, i) =>
                    <React.Fragment key={i}>
                        <PaymentRow config={props.config} data={data} index={i} payment={d} />
                    </React.Fragment>
                )
            }
        </Table>
    );
}

function PaymentRow(props) {
    const data = props.data || {};
    const config = props.config || {};
    const payment = props.payment || {};
    let blockProps = {};
    let formatProps = {};
    let includes = {};
    if (config.Config) {
        if (config.Config.Block) {
            blockProps = config.Config.Block;
        }
        if (config.Config.Format) {
            formatProps = config.Config.Format;
        }
        if (config.Config.Includes) {
            includes = config.Config.Includes;
        }
    }
    const styleLineItem = Utilities.Config.getStyle(data, blockProps, 'LineItem');
    if (props.index != 0) {
        if (!Utilities.isNullOrWhitespace(blockProps.lineSpacingLineItem)) {
            styleLineItem.paddingTop = blockProps.lineSpacingLineItem;
        }
    } else if (!Utilities.isNullOrWhitespace(blockProps.borderTopSpacing)) {
        styleLineItem.paddingTop = blockProps.borderTopSpacing;
    }
    const styleDate = { ...styleLineItem };
    if (!Utilities.isNullOrWhitespace(blockProps.marginLeft)) {
        styleDate.paddingLeft = blockProps.marginLeft;
    }
    let method;
    if (includes.Method) {
        const styleMethod = { whiteSpace: 'nowrap', ...styleLineItem };
        if (!Utilities.isNullOrWhitespace(blockProps.methodColumnWidth)) {
            styleMethod.width = blockProps.methodColumnWidth;
        }
        method = <Content.ValueWrapperCell columnSpacing={blockProps.columnSpacing} style={styleMethod}>{payment.Method}</Content.ValueWrapperCell>
    }
    const styleValue = { whiteSpace: 'nowrap', ...styleLineItem };
    if (!Utilities.isNullOrWhitespace(blockProps.valueColumnWidth)) {
        styleValue.width = blockProps.valueColumnWidth;
    }
    let localization;
    if (data.Gallery) {
        localization = data.Gallery.Localization;
    }
    return (
        <tr style={{ textAlign: 'right' }}>
            <Content.ValueWrapperCell columnSpacing={blockProps.columnSpacing} style={styleDate}>{payment.Date}</Content.ValueWrapperCell>
            {method}
            <Content.ValueWrapperCell columnSpacing={blockProps.marginRight} style={styleValue}>{Utilities.Format.Currency.getDisplayString(payment.Amount, formatProps.currencyFormat, localization)}</Content.ValueWrapperCell>
        </tr>
    );
}

function Table(props) {
    const data = props.data || {};
    const config = props.config || {};
    let blockProps = {};
    let includes = {};
    if (config.Config) {
        if (config.Config.Block) {
            blockProps = config.Config.Block;
        }
        if (config.Config.Includes) {
            includes = config.Config.Includes;
        }
    }
    let styleHeader;
    if (includes.HeaderLabel) {
        styleHeader = Utilities.Config.getStyle(data, blockProps, 'Header');
    }

    let styleTableHeader;
    if (includes.TableHeader) {
        styleTableHeader = Utilities.Config.getStyle(data, blockProps, 'TableHeader');
        styleTableHeader.marginBottom = undefined;
        styleTableHeader.paddingBottom = undefined;
    }
    const colSpan = includes.Method ? '3' : '2';

    let styleBorder;
    if (!Utilities.isNullOrWhitespace(blockProps.borderBottom)) {
        styleBorder = { borderBottom: blockProps.borderBottom };
    }
    if (!Utilities.isNullOrWhitespace(blockProps.borderBottomSpacing)) {
        styleBorder = styleBorder || {};
        styleBorder.paddingTop = blockProps.borderBottomSpacing;
    }
    let borderBottom;
    if (styleBorder) {
        borderBottom = <tr><td colSpan={colSpan} style={styleBorder} /></tr>;
    }
    const styleHeaderSpacer = {};
    if (!Utilities.isNullOrWhitespace(blockProps.borderTop)) {
        styleHeaderSpacer.borderBottom = blockProps.borderTop;
    }
    if (!Utilities.isNullOrWhitespace(blockProps.lineSpacingTableHeader)) {
        styleHeaderSpacer.paddingTop = blockProps.lineSpacingTableHeader;
    }
    const styleDate = {};
    const styleMethod = {};
    const styleValue = {};
    if (!Utilities.isNullOrWhitespace(blockProps.backgroundColorTableHeader)) {
        styleDate.backgroundColor = blockProps.backgroundColorTableHeader;
        styleMethod.backgroundColor = blockProps.backgroundColorTableHeader;
        styleValue.backgroundColor = blockProps.backgroundColorTableHeader;
    }
    if (!Utilities.isNullOrWhitespace(blockProps.marginLeft)) {
        styleDate.paddingLeft = blockProps.marginLeft;
    }
    if (!Utilities.isNullOrWhitespace(blockProps.columnSpacing)) {
        styleDate.paddingRight = blockProps.columnSpacing;
        styleMethod.paddingRight = blockProps.columnSpacing;
    }
    if (!Utilities.isNullOrWhitespace(blockProps.methodColumnWidth)) {
        styleMethod.width = blockProps.methodColumnWidth;
    }
    if (!Utilities.isNullOrWhitespace(blockProps.marginRight)) {
        styleValue.paddingRight = blockProps.marginRight;
    }
    if (!Utilities.isNullOrWhitespace(blockProps.valueColumnWidth)) {
        styleValue.width = blockProps.valueColumnWidth;
    }
    return (
        <Container
            builder={props.builder}
            className={props.className}
            config={props.config}
            onClick={props.onClick}
            onDragStart={props.onDragStart}>
            {
                props.children &&
                props.children.length > 0 &&
                <React.Fragment>
                    {
                        includes.HeaderLabel &&
                        <tr style={{ textAlign: 'right' }}>
                            <td colSpan={colSpan}>
                                <div style={styleHeader}>{blockProps.textLabelHeader}</div>
                            </td>
                        </tr>
                    }
                    {
                        includes.TableHeader &&
                        <tr style={{ textAlign: 'right' }}>
                            <td style={styleDate}><div style={styleTableHeader}>Date</div></td>
                            {
                                includes.Method &&
                                <td style={styleMethod}><div style={styleTableHeader}>Method</div></td>
                            }
                            <td style={styleValue}><div style={styleTableHeader}>Amount</div></td>
                        </tr>
                    }
                    <tr><td colSpan={colSpan} style={styleHeaderSpacer} /></tr>
                    {props.children}
                    {borderBottom}
                </React.Fragment>
            }
            {
                props.builder &&
                <tr>
                    <td>
                        {
                            (!props.children || props.children.length == 0) &&
                            Utilities.Builder.emptyBlockPlaceholder()
                        }
                        {Utilities.Builder.dragOutline()}
                    </td>
                </tr>
            }
        </Container>
    );
}

const TableTypeConfig = {
    panel: {
        block: function (label) {
            let labelValue;
            if (label && label.value) {
                labelValue = label.value;
            }
            return {
                label: 'Block Configuration',
                options: [
                    { display: 'Header Label Properties', id: 'headerProps', type: 'header' },
                    {
                        default: labelValue,
                        display: 'Display Text',
                        name: 'textLabelHeader',
                        type: 'text',
                        value: labelValue
                    },
                    { type: 'spacer' },
                    ...TypeConfig.options.text({ name: 'Header' }, {}, undefined, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Table Header Properties', id: 'tableHeaderProps', type: 'header' },
                    ...TypeConfig.options.text({ name: 'TableHeader' }, {}, {}, {}),
                    {
                        display: 'Background Color',
                        name: 'backgroundColorTableHeader',
                        type: 'text'
                    },
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Line Item Properties', id: 'lineItemProps', type: 'header' },
                    ...TypeConfig.options.text({ name: 'LineItem' }, {}, {}, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Table Properties', id: 'tableProps', type: 'header' },
                    {
                        display: 'Method Column Width',
                        name: 'methodColumnWidth',
                        type: 'text',
                        value: '15%'
                    },
                    {
                        display: 'Value Column Width',
                        name: 'valueColumnWidth',
                        type: 'text',
                        value: '10%'
                    },
                    {
                        display: 'Column Spacing',
                        name: 'columnSpacing',
                        type: 'text'
                    },
                    {
                        display: 'Margin Left',
                        name: 'marginLeft',
                        type: 'text'
                    },
                    {
                        display: 'Margin Right',
                        name: 'marginRight',
                        type: 'text'
                    },
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ...TypeConfig.options.border()
                ]
            };
        },
        format: function () { return TypeConfig.panel.currency(); },
        includes: function (refunds) {
            const options = [
                { display: 'Header Label', name: 'HeaderLabel', type: 'checkbox', value: true },
                { display: 'Table Header', name: 'TableHeader', type: 'checkbox', value: true },
                { display: 'Method', name: 'Method', type: 'checkbox', value: true }
            ];
            if (refunds) {
                options.push({ display: 'Refunds', name: 'Refunds', type: 'checkbox', value: true });
            }
            return {
                expanded: false,
                label: 'Include',
                options: options
            };
        },
        style: function () { return TypeConfig.panel.layoutStyle(); }
    }
};
const TypeConfigCredits = {
    panel: {
        block: function () { return TableTypeConfig.panel.block({ value: 'Credits' }); },
        format: TableTypeConfig.panel.format,
        includes: function () { return TableTypeConfig.panel.includes(); },
        style: TableTypeConfig.panel.style
    }
};
const TypeConfigPayments = {
    panel: {
        block: function () { return TableTypeConfig.panel.block({ value: 'Payments' }); },
        format: TableTypeConfig.panel.format,
        includes: function () { return TableTypeConfig.panel.includes({}); },
        style: TableTypeConfig.panel.style
    }
};

// #endregion LEGACY

module.exports = {
    CreditsTable: {
        V1: {
            Component: CreditsTable,
            TypeConfig: TypeConfigCredits
        },
        V2: {
            Component: CreditsTableV2,
            TypeConfig: TypeConfigCreditsV2
        }
    },
    PaymentsTable: {
        V1: {
            Component: PaymentsTable,
            TypeConfig: TypeConfigPayments
        },
        V2: {
            Component: PaymentsTableV2,
            TypeConfig: TypeConfigPaymentsV2
        }
    }
};